export default "__VITE_ASSET__BJsIR4uM__"